import type {
  MaintenanceRequest,
  PaymentsInvoice,
  PaymentsTransaction,
  TourModel,
} from '../core/Types';

const formatDate = (date: Date) => {
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

const buildPaymentsSeed = () => {
  const invoices: PaymentsInvoice[] = [];
  const transactions: PaymentsTransaction[] = [];
  const rentAmount = 1100;
  const startYear = 2024;
  const startMonth = 0;

  for (let i = 0; i < 12; i += 1) {
    const issuedDate = new Date(startYear, startMonth + i, 28);
    const dueDate = new Date(startYear, startMonth + i + 1, 1);
    const isOutstanding = i === 11;
    const docNo = String(615092 + i);
    const invoice: PaymentsInvoice = {
      id: `inv_${startYear}_${i + 1}`,
      docNo,
      issuedDate: formatDate(issuedDate),
      dueDate: formatDate(dueDate),
      balance: isOutstanding ? rentAmount : 0,
      total: rentAmount,
      status: isOutstanding ? 'outstanding' : 'paid',
      lineItems: [
        {
          id: `line_${startYear}_${i + 1}`,
          itemType: 'Rent',
          itemName: 'Rent',
          site: '#101 - Aurora Rapids',
          company: 'Trantow-Barton',
          description: 'Unit 3B monthly rent',
          quantity: 1,
          amount: rentAmount,
        },
      ],
    };
    invoices.push(invoice);
    transactions.push({
      id: `${invoice.id}-invoice`,
      kind: 'invoice',
      date: invoice.issuedDate,
      number: docNo,
      dueDate: invoice.dueDate,
      amount: invoice.total,
      outstanding: invoice.balance,
      balance: invoice.balance,
      statusLabel: isOutstanding ? 'Outstanding' : 'Paid',
      lineItems: invoice.lineItems,
    });

    if (!isOutstanding) {
      const paymentDate = new Date(startYear, startMonth + i + 1, 3);
      transactions.push({
        id: `${invoice.id}-payment`,
        kind: 'invoicePayment',
        date: formatDate(paymentDate),
        number: docNo,
        amount: -rentAmount,
        outstanding: 0,
        balance: 0,
        statusLabel: 'Applied',
        appliedItems: [
          {
            id: `${invoice.id}-applied-rent`,
            title: '#101 - Aurora Rapids',
            amount: rentAmount,
            quantity: 1,
            itemType: 'Rent',
            appliedTo: `Rent #${docNo}`,
            bankAccount: 'Bank of America',
          },
        ],
      });
    }
  }

  transactions.sort((a, b) => {
    const aDate = new Date(a.date).getTime();
    const bDate = new Date(b.date).getTime();
    return bDate - aDate;
  });

  return { invoices, transactions };
};

const buildMaintenanceSeed = (): MaintenanceRequest[] => {
  return [
    {
      id: 'MR-1042',
      title: 'Kitchen faucet leaking',
      category: 'Plumbing',
      propertyName: 'Aurora Rapids',
      unitName: 'Unit #3B',
      requestedAt: formatDate(new Date(2026, 1, 3)),
      priority: 'high',
      status: 'new',
      vendor: null,
      residentName: 'Andrew McDermott',
      description:
        'Water keeps dripping even when the handle is closed. Leak is getting worse at night.',
      entryNotes: 'Call before entering. Dog in unit is friendly.',
      contactPhone: '(555) 014-2231',
    },
  ];
};

export const seedModel = (): TourModel => ({
  payments: buildPaymentsSeed(),
  mode: 'manager',
  tenant: {
    name: 'Andrew McDermott',
    unitName: 'Unit #3B',
    propertyName: 'Aurora Rapids',
    balanceAmount: 1100,
    autoPayOn: true,
  },
  maintenance: {
    requests: buildMaintenanceSeed(),
  },
});
